"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.dissocPath = exports.dissoc = void 0;

// // _appendKey : ([k], v, k) -> [k]
// const _appendKey = (keys, val, key) => append(key, keys)
// _assign : ({ k: v }, { k: v }) -> { k: v }
var _assign = function (a, b) {
  // eslint-disable-next-line guard-for-in
  for (var key in b) {
    a[key] = b[key];
  }

  return a;
}; // // _comp : (a, b) -> Number
// const _comp = (a, b) => (a < b ? -1 : b < a ? 1 : 0)
// // _index : ({ k: Number }, String) -> { k: Number }
// const _index = (idx, key) => assoc(key, 1, idx)
// _partial : ((a... -> b), [a]) -> a... -> b


var _partial = function (f, args) {
  return f.bind(null, ...args);
}; // length : [a] -> Number


var length = function (list) {
  return list.length;
}; // unapply : ([a] -> b) -> a... -> b


var unapply = function (f) {
  return function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return f(args);
  };
}; // curryN : Number -> ((a, b, ...) -> z) -> a -> b -> ... -> z


var _curryN = function (n, f) {
  return n < 1 ? f : unapply(function (args) {
    var left = n - length(args);
    return left > 0 ? _curryN(left, _partial(f, args)) : f(...args);
  });
};

var curryN = _curryN(2, _curryN); // curry : ((a, b, ...) -> z) -> a -> b -> ... -> z


var curry = function (f) {
  return curryN(length(f), f);
}; // dissoc : k -> { k: v } -> { k: v }


var dissoc = function (key, obj) {
  var res = _assign({}, obj);

  delete res[key];
  return res;
}; // assoc : k -> v -> { k: v } -> { k: v }


exports.dissoc = dissoc;
var assoc = curry(function (prop, val, obj) {
  var res = _assign({}, obj);

  res[prop] = val;
  return res;
});
/* eslint-disable */
// dissocPath : [k] -> { k: v } -> { k: v }

var dissocPath = curry(function (_ref, obj) {
  var head = _ref[0],
      tail = _ref.slice(1);

  return !head ? obj : obj[head] == null ? obj : length(tail) ? assoc(head, dissocPath(tail, obj[head]), obj) : dissoc(head, obj);
});
/* eslint-enable */

exports.dissocPath = dissocPath;